import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

type RegistrationCategory = {
  title: string;
  description: string;
  buttonLabel: string;
  accent: string;
  icon: string;
  route: string;
};

@Component({
  selector: 'app-register-selection',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './registration-selection.component.html',
  styleUrls: ['./registration-selection.component.scss']
})
export class RegisterSelectionComponent {
  readonly categories: RegistrationCategory[] = [
    {
      title: 'QCA',
      description: 'Qualified Coordinating Agency managing injection / drawl scheduling for RE generators.',
      buttonLabel: 'Register as QCA',
      accent: 'blue',
      icon: '⚡',
      route: '/register/qca'
    },
    {
      title: 'Generating Company',
      description: 'Solar, wind, hydro or hybrid power generation entity connected to the state grid.',
      buttonLabel: 'Register as Generating Company',
      accent: 'amber',
      icon: '⚡',
      route: '/register/generating-company'
    },
    {
      title: 'Utility',
      description: 'Distribution company (DISCOM) or power trader purchasing renewable energy.',
      buttonLabel: 'Register as Utility',
      accent: 'green',
      icon: '▣',
      route: '/register/utility'
    },
    {
      title: 'PSS Owner',
      description: 'Pooling sub-station owner facilitating grid interconnection of RE plants.',
      buttonLabel: 'Register as PSS Owner',
      accent: 'violet',
      icon: '▤',
      route: '/register/pss'
    }
  ];
}
